import { AddIcon, CheckIcon } from "@chakra-ui/icons";
import { List, ListIcon, ListItem } from "@chakra-ui/react";

const Benefits = () => {
  return (
    <List spacing={1}>
      <ListItem fontSize="0.85em">
        <ListIcon as={CheckIcon} color="green.500" /> Unlimited tracking, beyond
        the 50 issue free preview
      </ListItem>
      <ListItem fontSize="0.85em">
        <ListIcon as={CheckIcon} color="green.500" />
        Direct links to the Marvel Unlimited and DC Universe Infinite apps
      </ListItem>
      <ListItem fontSize="0.85em">
        <ListIcon as={CheckIcon} color="green.500" /> Ability to create your own
        reading orders
      </ListItem>
      <ListItem fontSize="0.85em">
        <ListIcon as={CheckIcon} color="green.500" />
        Clone and edit any existing reading order
      </ListItem>
      <ListItem fontSize="0.85em">
        <ListIcon as={CheckIcon} color="green.500" />
        Reading order requests fulfilled within 28 days
      </ListItem>
      <ListItem fontSize="0.85em">
        <ListIcon as={CheckIcon} color="green.500" />
        Set reading goals and track your pace toward deadlines and challenges
      </ListItem>
      <ListItem fontSize="0.85em">
        <ListIcon as={CheckIcon} color="green.500" />
        Premium priority support via chat and email
      </ListItem>
      <ListItem fontSize="0.85em">
        <ListIcon as={AddIcon} color="white.500" />
        Early access to new features
      </ListItem>
    </List>
  );
};

export default Benefits;
